export default "__VITE_ASSET__Dh6pPZgp__"